import { IOnboardingComponentProps } from "pages/onboarding/[[...step]]";
import { EmailForm } from "@components/auth/components/EmailForm";

export const EmailStep = ({
  nextStep,
  setEmail,
  setName,
  isEmbed,
  handleSaveAnswer: _handleSaveAnswer,
}: IOnboardingComponentProps) => {
  return (
    <EmailForm
      isEmbed={isEmbed}
      sendOtpSuccess={(email, name) => {
        setEmail?.(email);
        setName?.(name);
        nextStep();
      }}
    />
  );
};
